import { useEffect, useState } from 'react';

export const useComponentLoading = () => {
  const [componentLoading, setComponentLoading] = useState(true);

  useEffect(() => {
    setComponentLoading(false);
  }, []);

  return componentLoading;
};
